export default (vacancyAgendaItem) => {
  let heading = '';
  let description = '';
  let media = '';

  if (vacancyAgendaItem.translation.title) {
    heading = `<h3 class="sh-agenda-item__title">${vacancyAgendaItem.translation.title}</h3>`;
  }

  if (vacancyAgendaItem.translation.description) {
    description = `
      <div class="sh-agenda-item__description cms-content prevent-share">
        ${vacancyAgendaItem.translation.description}
      </div>
    `;
  }

  if (vacancyAgendaItem.video) {
    media = `
      <div class="sh-agenda-item__video" data-controller="video">
        <div
          data-plyr-provider="${vacancyAgendaItem.video.source}"
          data-plyr-embed-id="${vacancyAgendaItem.video.id}"
        ></div>
      </div>
    `;
  } else if (vacancyAgendaItem.media_item) {
    media = `
      <img
        class="sh-agenda-item__image"
        src="${vacancyAgendaItem.media_item.url}"
        alt="${vacancyAgendaItem.media_item.alt}"
      >
    `;
  }

  return `
    <div class="sh-agenda-item">
      <div class="sh-agenda-item__column">
        ${heading}
        ${description}
      </div>

      <div class="sh-agenda-item__column">
        ${media}
      </div>
    </div>
  `;
};
